import { Lock, Sparkles } from "lucide-react";

export default function ComingSoonTab({ title, description, metrics = [] }) {
  return (
    <div className="bg-white border border-dashed border-slate-300 rounded-md p-10 text-center" data-testid="coming-soon-tab">
      <div className="inline-flex items-center justify-center h-12 w-12 rounded-md bg-slate-900 text-white mb-4">
        <Sparkles className="h-5 w-5" />
      </div>
      <h2 className="font-display text-2xl font-semibold text-slate-900">{title}</h2>
      <p className="text-sm text-slate-500 mt-2 max-w-xl mx-auto">{description}</p>

      {metrics.length > 0 && (
        <div className="mt-6 max-w-md mx-auto text-left bg-slate-50 border border-slate-200 rounded-md p-5">
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold mb-3 flex items-center gap-1.5">
            <Lock className="h-3 w-3" /> Métricas previstas
          </div>
          <ul className="space-y-2">
            {metrics.map((m, i) => (
              <li key={i} className="text-sm text-slate-700 flex items-start gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-slate-400 mt-2 shrink-0" />
                <span>{m}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-6 text-xs text-slate-400">
        Esta área se construirá en una próxima iteración. Si necesitás priorizarla, indicá qué métricas son críticas.
      </div>
    </div>
  );
}
